import '../../../app.css';
import '../../game.css';

const React = require('react');
const ModalWindow = require('../../../../core/modal').default;
const assets = require('../../../../assets').default;
const { getStageClearTitle, renderTwitterButton } = require('../../../../core/twitter').default;
const { getStageBonus, getClearStageScenario, getStartStageScenario, stageScenario } = require('../../../../core/stageData').default;
const styles = require('../../game.style').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================


const getScenarioImage = (arrivalStage) => {
    if (getClearStageScenario(arrivalStage) === stageScenario.SCENARIO_FINAL) {
        return assets.ModalMea02;
    }
    if (arrivalStage % 2 === 0) {
        return assets.ModalMea02;
    }
    return assets.ModalMea03;
}

export default class stageClearComponent extends React.Component {
    renderScenario() {
        const { gameState: { arrivalStage }, playerState: { playerName } } = this.props;
        if (getClearStageScenario(arrivalStage) === stageScenario.SCENARIO_FINAL) {
            return (
                <>
                    <div className="modal-messages-content">王女メア：</div>
                    <div className="modal-messages-content">ようやく魔女を追い詰めました！次はいよいよ、魔女が待つ神殿です！</div>
                    <div className="modal-messages-content">{playerName}様！　気を引き締めて挑みましょう！</div>
                </>
            )
        } else {
            return (
                <>
                    <div className="modal-messages-content">王女メア：</div>
                    <div className="modal-messages-content">さすが{playerName}様！ 次のステージも頑張りましょう！</div>
                </>
            )
        }
    }

    renderContents() {
        const { gameState: { arrivalStage }, playerState: { playerName } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="dialog">
                    <div className="dialog-header-bg">
                        <div className="dialog-header">Stage Clear</div>
                    </div>
                    <div className="dialog-contents">
                        <div className="dialog-row">
                            <div className="modal-messages">
                                <div className="modal-messages-header">ステージ {arrivalStage} クリア!!</div>
                                {this.renderScenario()}
                                <div className="modal-messages-score">
                                    <div className="modal-messages-score-data">
                                        <img src={assets.ScoreCoin} className="info-body-info-param-score-img" />
                                        <div className="info-body-info-param-score-num">
                                            クリア報酬:{getStageBonus(arrivalStage)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-illuast">
                                <img className="modal-illuast-img" src={getScenarioImage(arrivalStage)} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-buttons">
                            <div className="btn-modal" onClick={() => {
                                sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                                this.props.handleNextClick(arrivalStage + 1, getStartStageScenario(arrivalStage + 1))
                            }}>次のステージへ</div>
                            <div className="btn-modal" onClick={() => {
                                sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                                this.props.handleTitleClick()
                            }}>探索を終了する</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            isCloseOutOfArea={false}
            contents={this.renderContents()}
            closeMs={0}
        />
    }
}